/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

export const config = {
    backendUrl: "https://api.leet-auth.dev/"
};



// WEBPACK FOOTER //
// ./src/config.js